import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { CustomerUser } from '@src/app/models/customeruser';
import { Customer } from '@src/app/models/customer';
import { CustomerpageService } from './service/customerpage.service';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerpage',
  templateUrl: './customerpage.component.html',
  styleUrls: ['./customerpage.component.css']
})
export class CustomerpageComponent implements OnInit {
  Collabrorator:boolean;
  modalCustomer:Customer;
  customerId:string;
  createCustomerUser:CustomerUser = new CustomerUser;
  editCustomerUser:CustomerUser = new CustomerUser;
  @Output() userToAdd:CustomerUser;
  @Output() readonly:boolean = true;
  @Output() editstate:string = "Make changes";
  @Output() errorMessage:string;
  projecttoggler:boolean = false;
  isSaving:boolean = false;

  hubspotintegration:boolean = true;
  deletebutton:boolean;
  @ViewChild('closemodal',{static:true}) closemodal:ElementRef;
  @ViewChild('closeeditmodal',{static:true}) closeeditmodal:ElementRef;

  modules = {
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      // onSelect: (item, insertItem) => {
      //   const editor = this.editor.quillEditor
      //   insertItem(item)
      //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
      //   editor.insertText(editor.getLength() - 1, '', 'user')
      // },
      // source: (searchTerm, renderList) => {
      //   const members = this.projectMembers.concat(this.projectCustomerMembers)
      //   const values = [];
      //   for (let index = 0; index < members.length; index++) {
      //     values.push({id: members[index].personId, value: members[index].fullname});
      //   }

      //   if (searchTerm.length === 0) {
      //     renderList(values, searchTerm)
      //   } else {
      //     const matches = []

      //     values.forEach((entry) => {
      //       if (entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
      //         matches.push(entry)
      //       }
      //     })
      //     renderList(matches, searchTerm)
      //   }
      // }
    },
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],          
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link']
    ],
  };
  
  constructor(private cpsrv:CustomerpageService, 
    private route:ActivatedRoute, 
    private router:Router,
    private auth:AuthorizationService,
    private uieventhub:UieventhubService) { }

  ngOnInit() {
    this.uieventhub.addLoader('customerpage');
    this.hubspotintegration = SessionHelper.getHubspot() ? true : false;
    this.customerId = this.route.snapshot.paramMap.get('customerId').split('_')[0];
    this.modalCustomer = new Customer;
    this.Collabrorator = false;
    this.cpsrv.getCustomer(this.customerId,new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(cus =>{
      this.modalCustomer = cus;
      this.modalCustomer.customerType = this.modalCustomer.customerType || 'normal';
      setTimeout(() => {
        this.uieventhub.removeLoader('customerpage');
      }, 100);
      const website = String(this.modalCustomer.website || '');
      if(website && website.split('http').length == 1){
        this.modalCustomer.website = 'https://' + website;
      }
    }, _error => {
      this.uieventhub.removeLoader('customerpage');
      this.errorMessage = 'Failed to load customer.';
    })
  }

  private closeEditModalSafely() {
    this.closeeditmodal.nativeElement.click();

    // Defensive cleanup for Bootstrap backdrop/body lock that can leave the page non-interactive.
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    }, 0);
  }
  showCustomerView(){
    SessionHelper.setCustomer(JSON.stringify(this.modalCustomer));
    SessionHelper.setViewAsCustomer('true');
    this.uieventhub.setViewAsCustomer(this.customerId );
    if(this.modalCustomer.customerType == 'normal'){
    this.router.navigate(['/customerportal']);
    }else{
    this.router.navigate(['/customerlight']);
    }
  }
  toggleprojects(){
    this.projecttoggler = !this.projecttoggler;
  }
  showEdit(){
    return this.auth.isAuthorized('org_edit',this.modalCustomer.organizationId);
  }
  CollabroratorControl(){
    this.Collabrorator = true;
  }
  userToAddEvent(user:CustomerUser){
    this.userToAdd = user;
    this.closemodal.nativeElement.click();

  
  }
  addNewUserToList(user:CustomerUser){
    //console.log('add new user in c page reached');
    this.userToAdd = user;
  }
  onChange(){
      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.errorMessage = '';

      this.cpsrv.updateCustomer(this.modalCustomer).pipe(untilDestroyed(this)).subscribe(custId => {
        this.modalCustomer.customerId = String(custId || this.modalCustomer.customerId);
        this.closeEditModalSafely();
        if (SessionHelper.getViewAsCustomer()) {
          SessionHelper.setCustomer(JSON.stringify(this.modalCustomer));
          this.uieventhub.setViewAsCustomer(this.modalCustomer.customerId);
        }
        this.isSaving = false;
      }, _error => {
        this.errorMessage = 'Failed to save customer changes.';
        this.isSaving = false;
      });
  }
  onDelete(){
    this.cpsrv.deleteCustomer(this.modalCustomer).pipe(untilDestroyed(this)).subscribe(done => {
      this.router.navigate(['/customers']);
    });
  }

}
